// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.right_inner_inner_banner {
  position: relative;
}

.banner1_box {
  position: relative;
}

.banner1_box.travel_boxxx:before {
  content: "";
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.4);
}

.banner1_box.travel_boxxx .banner1_overlay {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 100%;
  left: 0;
  right: 0;
  margin: auto;
  background: rgba(255, 255, 255, 0.7);
  padding: 10px;
  text-align: center;
  bottom: auto;
  font-size: 38px;
  color: #111 !important;
  font-weight: 500;
  text-transform: uppercase;
}
.pre_partner_overlay h4 {
  font-size: 2rem;
}
.pre_partner_overlay p {
  font-size: 1rem;
  text-transform: capitalize;
  margin: 0;
  color: #1a1b1c;
  font-weight: normal;
}
.banner1_box.travel_boxxx {
  width: 100%;
  border-radius: 10px;
  overflow: hidden;
  height: 350px;
  position: relative;
  z-index: 1;
  display: block;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.5);
}

.banner2_box {
  position: relative;
}

.banner2_box.travel_boxxx:before {
  content: "";
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  /* background: rgba(0,0,0,0.4); */
}

.banner2_box.travel_boxxx .banner1_overlay {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 100%;
  left: 0;
  right: 0;
  margin: auto;
  background: rgba(255, 255, 255, 0.7);
  padding: 10px;
  font-size: 38px;
  color: #111 !important;
  font-weight: 500;
  text-transform: uppercase;
  text-align: center;
  bottom: auto;
}

.banner2_box.travel_boxxx {
  width: 100%;
  border-radius: 10px;
  overflow: hidden;
  height: 350px;
  position: relative;
  z-index: 1;
  display: block;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.5);
}
`, "",{"version":3,"sources":["webpack://./src/pages/dashboard/training-video-dashboard/training-video-dashboard.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,MAAM;EACN,SAAS;EACT,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,2BAA2B;EAC3B,WAAW;EACX,OAAO;EACP,QAAQ;EACR,YAAY;EACZ,oCAAoC;EACpC,aAAa;EACb,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,sBAAsB;EACtB,gBAAgB;EAChB,yBAAyB;AAC3B;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;EACf,0BAA0B;EAC1B,SAAS;EACT,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;EACb,kBAAkB;EAClB,UAAU;EACV,cAAc;EACd,uCAAuC;AACzC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,MAAM;EACN,SAAS;EACT,iCAAiC;AACnC;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,2BAA2B;EAC3B,WAAW;EACX,OAAO;EACP,QAAQ;EACR,YAAY;EACZ,oCAAoC;EACpC,aAAa;EACb,eAAe;EACf,sBAAsB;EACtB,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;EACb,kBAAkB;EAClB,UAAU;EACV,cAAc;EACd,uCAAuC;AACzC","sourcesContent":[".right_inner_inner_banner {\n  position: relative;\n}\n\n.banner1_box {\n  position: relative;\n}\n\n.banner1_box.travel_boxxx:before {\n  content: \"\";\n  position: absolute;\n  left: 0;\n  right: 0;\n  top: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.4);\n}\n\n.banner1_box.travel_boxxx .banner1_overlay {\n  position: absolute;\n  top: 50%;\n  transform: translateY(-50%);\n  width: 100%;\n  left: 0;\n  right: 0;\n  margin: auto;\n  background: rgba(255, 255, 255, 0.7);\n  padding: 10px;\n  text-align: center;\n  bottom: auto;\n  font-size: 38px;\n  color: #111 !important;\n  font-weight: 500;\n  text-transform: uppercase;\n}\n.pre_partner_overlay h4 {\n  font-size: 2rem;\n}\n.pre_partner_overlay p {\n  font-size: 1rem;\n  text-transform: capitalize;\n  margin: 0;\n  color: #1a1b1c;\n  font-weight: normal;\n}\n.banner1_box.travel_boxxx {\n  width: 100%;\n  border-radius: 10px;\n  overflow: hidden;\n  height: 350px;\n  position: relative;\n  z-index: 1;\n  display: block;\n  box-shadow: 0 0 10px rgba(0, 0, 0, 0.5);\n}\n\n.banner2_box {\n  position: relative;\n}\n\n.banner2_box.travel_boxxx:before {\n  content: \"\";\n  position: absolute;\n  left: 0;\n  right: 0;\n  top: 0;\n  bottom: 0;\n  /* background: rgba(0,0,0,0.4); */\n}\n\n.banner2_box.travel_boxxx .banner1_overlay {\n  position: absolute;\n  top: 50%;\n  transform: translateY(-50%);\n  width: 100%;\n  left: 0;\n  right: 0;\n  margin: auto;\n  background: rgba(255, 255, 255, 0.7);\n  padding: 10px;\n  font-size: 38px;\n  color: #111 !important;\n  font-weight: 500;\n  text-transform: uppercase;\n  text-align: center;\n  bottom: auto;\n}\n\n.banner2_box.travel_boxxx {\n  width: 100%;\n  border-radius: 10px;\n  overflow: hidden;\n  height: 350px;\n  position: relative;\n  z-index: 1;\n  display: block;\n  box-shadow: 0 0 10px rgba(0, 0, 0, 0.5);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
